import { useAuthStore } from '../stores/auth.store';

/**
 * Reactive auth state for components. Returns the current user, whether a
 * session exists, and whether the initial session resolution has completed.
 */
export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const tokens = useAuthStore((s) => s.tokens);
  const isInitialized = useAuthStore((s) => s.isInitialized);

  return {
    user,
    isAuthenticated: Boolean(tokens?.accessToken),
    isInitialized,
  };
}
